import React, {Component} from 'react';
import cx from 'classnames';

export default class RadioGroup extends Component {
    render() {
        const { options, label, disable, input, required, eng } = this.props;
        const labelStyles = cx('fc-input__label', {
            'fc-input__label--hidden': !label,
            'fc-input__label--disable': disable
        });
        // const inputStyles = cx('fc-input__input', {'fc-input__input--disable': disable});

        return (
            <div className="fc-input-wrapper">
                <ul className="fc-radiogroup">
                    {options.map(el => <li className="fc-radio" key={el.value}>
                        <input
                            type="radio"
                            className="fc-radio__radio"
                            name={el.name}
                            value={el.value}
                            id={`${el.name}-${el.value}`}
                            onChange={input.onChange}
                            required={required} />
                        <label htmlFor={`${el.name}-${el.value}`} className="fc-radio__label">{el.label}</label>
                    </li>)
}
                </ul>
                <label className={labelStyles}>
                    {label} {eng && <span className="label-eng">[{eng}]</span>}
                </label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/User/components/RadioGroup.js